/* eslint-disable class-methods-use-this */
import {
  GROUPING_TYPE,
  WDH_GROUPING_TYPE,
} from 'utils/__enums/Administration/Organization'
import { HierarchyEntity } from 'utils/__interfaces/Administrations/Organizations/ManageOrganization'
import OrganizationWDH from 'utils/__interfaces/Administrations/Organizations/OrganizationWDH'

class HierarchyNormalizer {
  normalize(organizationList: OrganizationWDH[]): HierarchyEntity[] {
    return organizationList.map(
      ({
        idOrganisation,
        nomOrganisation,
        organisationsEnfant,
        nbContrats,
        typeOrganisation,
      }) => {
        return {
          id: String(idOrganisation),
          name: nomOrganisation,
          childrenOrganization: organisationsEnfant.map(
            ({ fkorganisationenfant }) =>
              fkorganisationenfant.replace('/organisations/', '')
          ),
          nbContracts: nbContrats ?? 0,
          typeOrganisation:
            typeOrganisation === WDH_GROUPING_TYPE.WDH_BY_ORGANIZATION
              ? GROUPING_TYPE.BY_ORGANIZATION
              : GROUPING_TYPE.BY_CONTRACT,
        }
      }
    )
  }
}

export default new HierarchyNormalizer()
